const hash = {"de":"9c0636312ff277531253086057d51a15","en":"529491582b89f7e35514c8a9d4b286c2","it":"0279d426fbf9c8355a80f3c4962a965b","ru":"1d35a8b5230764c6b7775ed5aecba7a2","sv":"53de0fe4ecbe5028210883b82f69e128"}
export default hash